import {Inertia} from "@inertiajs/inertia";
import NProgress from "nprogress";

require('./bootstrap');

import { createApp, h } from 'vue';
import {createInertiaApp, usePage} from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
import EventBus from './Helpers/event-bus';
import { VueMaskDirective } from "v-mask";

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Bookings';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => import(`./Pages/${name}`),
    setup({ el, app, props, plugin }) {
        const vueApp = createApp({ render: () => h(app, props) })
            .use(plugin)
            .mixin({
                methods: {
                    route: route, //ziggy routes
                    prefixedRoute: function (name, params){

                        //if we have a basket use it for the route
                        if(usePage().props.value?.basket?.uuid){
                            return this.route(
                                `basket.${name}`,
                                {
                                    basket: usePage().props.value?.basket?.uuid,
                                    ...params
                                }
                            );
                        }

                        return this.route(name, params);
                    },
                    asset: (path) => {
                        //future-proofing it so if the assets end up on s3 (vapor) the assets can still work
                        return (process.env.MIX_ASSET_URL || '') + '/' + path.replace(/^\/+/, '')
                    },
                    toastr: function(type = 'error', message = '', options = {}) {
                        //trigger the event for toast and the toast component in the app-layout will pick it up
                        //and render the message in a toast
                        this.$eventBus.trigger('toast', {
                            type    : type,
                            message : message,
                            options : options
                        });
                    },
                },
            })
            .directive('mask', {
                //this library was built for vue2 but vue3 only requires a change of name for the hooks
                beforeMount : VueMaskDirective.bind,
                updated     : VueMaskDirective.componentUpdated,
                unmounted   : VueMaskDirective.unbind
            });

        //equivalent of a vue2 event bus so I can pass data to different components
        //currently in use for the toasts
        vueApp.config.globalProperties.$eventBus = EventBus;

        return vueApp.mount(el);
    },
});


NProgress.configure({
    template: `<div class="progress-wave">
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="bar" role="bar">
            <div class="peg"></div>
        </div>
        <div class="spinner" role="spinner">
            <div class="spinner-icon">
        </div>
    </div>`
});

InertiaProgress.init({
    color       : '#013785',
    showSpinner : true
});
